import React from 'react';
import { PropTypes } from 'prop-types';

// styles
import styled from 'styled-components';
import { expandHeightAndWidth, Flex } from 'utils/style';
// components
import AppBar from '../nav/appBar';
import LoadSpinner from 'components/LoadSpinner';

const Content = styled.div`
  width: 100%;
  height: 100%;
  ${Flex.column}
  ${Flex.center}
    color: var(--primary500);
`;

const LoadingView = ({ className }) => (
  <div className={className}>
    <AppBar isLoading={true} />
    <Content>
      <LoadSpinner size="12" />
    </Content>
  </div>
);

LoadingView.propTypes = {
  className: PropTypes.string,
};

const StyledLoadingView = styled(LoadingView)`
  ${expandHeightAndWidth()}
`;

export default StyledLoadingView;
